import { client } from "@/lib/hono";
import toast from "@/lib/toast";
import { SrclangType, VideoInteraction } from "@yedalabs/schema";
import { useQueryClient } from "@tanstack/react-query";
import { Dispatch, SetStateAction, useState } from "react";
import { t } from "@/lib/localization";

interface UseSaveInteractionsProps {
    videoId: string;
    interactions: VideoInteraction[];
    srclang?: SrclangType;
    setReloadVideoKey: Dispatch<SetStateAction<number>>;
}

export const useSaveInteractions = ({
    videoId,
    interactions,
    srclang,
    setReloadVideoKey,
}: UseSaveInteractionsProps) => {
    const [loading, setLoading] = useState(false);
    const [changes, setChanges] = useState(false);

    const queryClient = useQueryClient();

    const saveChanges = async () => {
        if (!srclang) return;

        setLoading(true);

        const res = await client.api.storage["video-interactions"][
            ":videoId"
        ].$post({
            param: { videoId },
            json: {
                srclang,
                interactions: interactions.map(
                    ({ createdAt, updatedAt, ...i }) => ({
                        ...i,
                        content: JSON.stringify(i.content),
                    })
                ),
            },
        });

        const resJson = await res.json();
        console.log({ resJson });

        if (!res.ok) {
            toast.error(t("toast.error.save-interactions"), {
                keyName: "toast.error.save-interactions",
            });
            setLoading(false);
            return;
        }

        queryClient.invalidateQueries({
            queryKey: ["get-interactions", videoId],
        });

        setReloadVideoKey(Date.now());
        toast.success(t("toast.success.changes-saved"), {
            keyName: "toast.success.changes-saved",
        });

        setLoading(false);
        setChanges(false);
    };

    return {
        loading,
        changes,
        setChanges,
        saveChanges,
    };
};
